<p-toast
  [baseZIndex]="5000"
  [hideTransformOptions]="'translateX(100%)'"
  [hideTransitionOptions]="'250ms ease-in'"
  [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'300ms ease-out'"
  position="top-right"
></p-toast>
